import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  INotification,
  IGetAllNotifications,
  INotificationState,
} from "../types/notification";

const initialState: INotificationState = {
  notifications: [],
  notification: null,
  total: 0,
  last_page: 1,
  current_page: 1,
  loading: false,
  error: null,
  deletingIds: [], // Track which notifications are being deleted
};

export const notification = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<IGetAllNotifications>) => {
      state.notifications = action.payload.data;
      state.last_page = action.payload.last_page;
      state.current_page = action.payload.current_page;
      state.total = action.payload.total;
    },
    setNotification: (state, action: PayloadAction<INotification>) => {
      state.notification = action.payload;
    },
    createNotification: (state, action: PayloadAction<INotification>) => {
      state.notifications = [action.payload, ...state.notifications];
      state.total += 1;
    },
    deleteNotification: (state, action: PayloadAction<number>) => {
      state.notifications = state.notifications.filter(
        (item) => item.id !== action.payload
      );
      state.total = Math.max(0, state.total - 1);
      // Remove from deletingIds when done
      state.deletingIds = state.deletingIds.filter(
        (id) => id !== action.payload
      );

      // Clear current notification if it's the one being deleted
      if (state.notification?.id === action.payload) {
        state.notification = null;
      }
    },
    // Add deleting state management
    startDeleting: (state, action: PayloadAction<number>) => {
      if (!state.deletingIds.includes(action.payload)) {
        state.deletingIds.push(action.payload);
      }
    },
    stopDeleting: (state, action: PayloadAction<number>) => {
      state.deletingIds = state.deletingIds.filter(
        (id) => id !== action.payload
      );
    },
    setNotificationLoading: (state) => {
      state.loading = true;
    },
    disableNotificationLoading: (state) => {
      state.loading = false;
    },
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.notification = null;
      state.total = 0;
      state.last_page = 1;
      state.current_page = 1;
      state.error = null;
      state.deletingIds = [];
    },
  },
});

export const {
  setNotifications,
  setNotification,
  createNotification,
  deleteNotification,
  startDeleting,
  stopDeleting,
  setNotificationLoading,
  disableNotificationLoading,
  setLoading,
  setError,
  clearError,
  clearNotifications,
} = notification.actions;

export default notification.reducer;
